module.exports = __webpack_public_path__ + "static/media/mari_desktop--feature.573cb9d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mari/mari_desktop--feature.png
// module id = 89
// module chunks = 0